import React from "react";
import UserDashBoardLayout from "../../../layout/DashBoardLayouts/UserDashBoardLayout";
import { RecomedSlides, ShortVideoSLides } from "../../../data/Data";
import VideoCardDetailed from "../../../component/VideoCardDetailed";
import { Row, Col } from "react-bootstrap";
import MainSlider from "../../../component/sliders/MainSlider";
import ShotVideoCard from "../../../component/ShortVideoCard";
import {
  DashboardShortSliderSetting,
  RecomedSliderSettings,
} from "../../../data/SliderSettings";
const FindProperty = () => {
  return (
    <>
      <UserDashBoardLayout>
        <section className="filters pb-5">
          <Row>
            <Col xs={12}>
              <h2 className="text-capitalize text-shark font-rubic fw-500">
                saved properties
              </h2>
            </Col>
            {RecomedSlides.map((Item) => (
              <Col className="mt-3">
                <div key={Item.id}>
                  <VideoCardDetailed
                    ClassProperty="m-1 recomend-card"
                    title={Item.title}
                    propertImage={Item.propertImage}
                    clientname={Item.clientname}
                    timeline={Item.timeline}
                  />
                </div>
              </Col>
            ))}
          </Row>
        </section>
        <MainSlider
          SliderSetting={RecomedSliderSettings}
          ClassProperty="py-5"
          SectionTitle="Featured properties"
          SectionSubTitle="
        Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Eveniet, ipsa illo."
        >
          {RecomedSlides.map((Item) => (
            <div key={Item.id}>
              <VideoCardDetailed
                ClassProperty="m-1 recomend-card"
                title={Item.title}
                propertImage={Item.propertImage}
                clientname={Item.clientname}
                timeline={Item.timeline}
              />
            </div>
          ))}
        </MainSlider>
        <MainSlider
          SliderSetting={RecomedSliderSettings}
          ClassProperty="py-5"
          SectionTitle="Featured projects"
          SectionSubTitle="
        Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Eveniet, ipsa illo."
        >
          {RecomedSlides.map((Item) => (
            <div key={Item.id}>
              <VideoCardDetailed
                ClassProperty="m-1 recomend-card"
                title={Item.title}
                propertImage={Item.propertImage}
                clientname={Item.clientname}
                timeline={Item.timeline}
              />
            </div>
          ))}
        </MainSlider>
        <MainSlider
          SliderSetting={DashboardShortSliderSetting}
          ClassProperty="py-5"
          SectionTitle="Shorts of Property"
          SectionSubTitle="
        Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Eveniet, ipsa illo."
        >
          {ShortVideoSLides.map((Item) => (
            <div key={Item.id}>
              <ShotVideoCard
                ClassProperty=""
                Thumbnel={Item.url}
                title={Item.title}
              />
            </div>
          ))}
        </MainSlider>
      </UserDashBoardLayout>
    </>
  );
};

export default FindProperty;
